import { render, staticRenderFns } from "./UploadMp4Dialog.vue?vue&type=template&id=b7107de6&scoped=true"
import script from "./UploadMp4Dialog.vue?vue&type=script&lang=js"
export * from "./UploadMp4Dialog.vue?vue&type=script&lang=js"
import style0 from "./UploadMp4Dialog.vue?vue&type=style&index=0&id=b7107de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7107de6",
  null
  
)

export default component.exports